let container = document.querySelector('.c1013')
let tabs = container.querySelectorAll('.tabs [data-filter]')
let tabsContent = container.querySelectorAll('.tabs-content [data-filter]')
tabs.forEach((tab) => {
    tab.addEventListener('click', ()=> {
        filterTabsContent(tab.dataset.filter)
        tabs.forEach((tab) => {
            tab.classList.remove('js-active')
        })
        tab.classList.add('js-active')
    })
})

function filterTabsContent (filter) {
    tabsContent.forEach((tabContent) => {
        if (filter === 'all-categories') {
            tabContent.classList.remove('hidden')
        } else if (tabContent.dataset.filter === filter) {
            tabContent.classList.remove('hidden')
        } else {
            tabContent.classList.add('hidden')
        }
    })
}